import { useContext } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';
import ColorPicker from '../components/ColorPicker';
import ImageUploader from '../components/ImageUploader';

export default function GlobalEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.global);
  useUnsavedChanges(isDirty);

  const handleSave    = () => save(patch => updateSection('global', patch));
  const handleDiscard = () => discard(content.global);

  return (
    <div className="adm-page">
      <AdminTopbar title="Global / Brand" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Brand</h3>

          <div className="adm-field">
            <label className="adm-label">Site Name</label>
            <input className="adm-input" value={draft.siteName || ''}
              onChange={e => update({ siteName: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Tagline</label>
            <input className="adm-input" value={draft.tagline || ''}
              onChange={e => update({ tagline: e.target.value })} />
          </div>

          <ImageUploader
            label="Logo"
            value={draft.logo || ''}
            onChange={v => update({ logo: v })}
            storagePath="brand"
          />
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Colours</h3>

          <ColorPicker label="Primary Colour"
            value={draft.primaryColor || '#3b82f6'}
            onChange={v => update({ primaryColor: v })} />

          <ColorPicker label="Accent Colour"
            value={draft.accentColor || '#8b5cf6'}
            onChange={v => update({ accentColor: v })} />

          <ColorPicker label="Background Colour"
            value={draft.bgColor || '#0a0a0a'}
            onChange={v => update({ bgColor: v })} />
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">SEO</h3>

          <div className="adm-field">
            <label className="adm-label">Meta Title</label>
            <input className="adm-input" value={draft.metaTitle || ''}
              onChange={e => update({ metaTitle: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Meta Description</label>
            <textarea className="adm-textarea" rows={3} value={draft.metaDescription || ''}
              onChange={e => update({ metaDescription: e.target.value })} />
          </div>
        </section>
      </div>
    </div>
  );
}
